import { useSelector } from 'react-redux'
import { globalRoles } from '../../../utils/globalRoles'

export const CheckUserRole = () => {

    const { user: { role = "" } = {} } = useSelector(state => state?.auth)

    const isAdmin = Boolean(role === globalRoles?.admin || role === globalRoles?.superAdmin);

    const isManager = Boolean(role === globalRoles?.manager);

    const isAssociate = Boolean(role === globalRoles?.associate);

    return {
        isAdmin,
        isManager,
        isAssociate
    }
} 